module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel_03-b2a54fd08744d64fa9d2da707ffaf0f9.jpg";